import { ApisauceInstance, create } from 'apisauce';

import { apiMethods, Config } from '@nw/shared/config';

import { SendUserEventRequestType } from './types';

import { IbExternalServicesTypes } from '.';

type NetworkCallWithAPISauce = <T>(
  api: ApisauceInstance,
  url: string,
  requestObject: unknown,
  method: string
) => Promise<T>;

class IbExternalServices implements IbExternalServicesTypes {
  api = create({ baseURL: `${Config['IB_EXTERNAL_SERVICE_BASE_URL']}` });
  networkCallWithAPISauce: NetworkCallWithAPISauce;

  constructor(networkCallWithAPISauce: NetworkCallWithAPISauce) {
    this.networkCallWithAPISauce = networkCallWithAPISauce;
  }

  sendUserEvent = (requestObject: SendUserEventRequestType): Promise<void> => {
    return this.networkCallWithAPISauce(
      this.api,
      'user/event/send/v1/',
      requestObject,
      apiMethods.post
    );
  };
}

export { IbExternalServices };
